import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { LayoutsModule } from './common/layouts/layouts.module';
import { RouterModule } from '@angular/router';

import { ROUTES } from './app.routes';
import { HomeModule } from './views/home/home.module';
import { VoucherCovidModule } from './views/voucher-covid/voucher-covid.module';
import { TransportBonusModule } from './views/transport-bonus/transport-bonus.module';
import { ServicePayModule } from './views/service-pay/service-pay.module';

import { httpFactory }  from './http.factory';
import { Http, XHRBackend, RequestOptions, HttpModule } from '@angular/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { LocatelliHomeService } from './services/locatelliHome.service';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';




@NgModule({
  declarations: [
    AppComponent,

  ],
  imports: [
    BrowserModule,
    LayoutsModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    HomeModule,
    VoucherCovidModule,
    TransportBonusModule,
    ServicePayModule,

   // NgbModule.forRoot(),
    RouterModule.forRoot(ROUTES, {useHash: true}),
    NgbModule.forRoot(),
    ModalModule.forRoot(),
    TimepickerModule.forRoot()

  ],
  providers: [
    {
    provide: Http,
    useFactory: httpFactory,
    deps: [XHRBackend, RequestOptions]
    },
    {
    provide: LocationStrategy,
    useClass: HashLocationStrategy
    },
    LocatelliHomeService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts